import './ProductToolControlBlock.less';
import React, {useState, useEffect} from 'react';


export default function ProductToolControlBlock({
    children,
    title,
    extra = null,
    heightLimited = true
}) {

    return <div className="product-tool-control-block">
        <div className="heading">
            <div className="title">
                {title}
            </div>
            {
                extra &&
                <div className="extra">
                    {extra}
                </div>
            }
        </div>
        <div className={`body ${heightLimited ? 'height-limited' : ''}`}>
            {children}
        </div>
    </div>
}

